import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getControlListRequested() {
    return {
        type: 'GET_CONTROL_LIST_REQUESTED'
    };
}

export function getControlListDone(data) {
    return {
        type: 'GET_CONTROL_LIST_DONE',
        payload: data
    };
}

export function getControlListFailed(error) {
    return {
        type: 'GET_CONTROL_LIST_FAILED',
        payload: error
    };
}

export function getActiveListData() {
    let url = PropertyBucket.getActiveLists();
    return dispatch => {
        dispatch(getControlListRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            dispatch(getControlListDone(data));
        })
            .catch(error => {
                dispatch(getControlListFailed(error));
            })
    }
}

export function getSingleListData(listId) {
    let url = PropertyBucket.getList(listId);
    return dispatch => {
        dispatch(getControlListRequested());
        let response = httpService.getService(url, "GET");
            response.then(data => {
                dispatch(getControlListDone(data));
            })
            .catch(error => {
                dispatch(getControlListFailed(error));
            })
    }
}

export const GET_CONTROL_LIST_DATA_REQUESTED = 'GET_CONTROL_LIST_REQUESTED';
export const GET_CONTROL_LIST_DATA_DONE = 'GET_CONTROL_LIST_DONE';
export const GET_CONTROL_LIST_DATA_FAILED = 'GET_CONTROL_LIST_FAILED';

